import { instance } from "apis/interceptor";

//UPDATE: (new) TUSER 객체
//TODO: 이후 types 폴더로 이전 필요
export type TUser = {
  id: string;
  nickname: string;
  image?: string;
  role: number;
  accessedAt: string;
  deleteFlag: boolean;
  workspace: TWorkspace;
};

//UPDATE: (new) TWorkspace 객체
//TODO: 이후 types 폴더로 이전 필요
export type TWorkspace = {
  id: string;
  name: string;
  image?: string;
  limitInvitation: number;
  sendInvitation: number;
  deleteFlag: boolean;
};

//UPDATE: (new) 본인이 속한 members(workspace)조회
export const getUsersMemberList = async (): Promise<{ success: boolean; members?: TUser[]; message?: string }> => {
  try {
    const res = await instance.get("/users/member/list");
    return { success: true, members: res.data };
  } catch (error: any) {
    console.error(error);
    return { success: false, message: error ?? "" };
  }
};
